import { UI } from '@genial/components';
import { BoxBorder, Color, Spacing } from '@genial/design-tokens';
import { Modal, ScrollView } from 'native-base';
import { Dimensions } from 'react-native';

import { useRecoilQuery } from '../../../../../../../../../hooks/useRecoilQuery';
import { publicOfferDetailsQuery } from '../../../../../../../../../store/product/selectors';
import {
  PublicOfferDetailsNormalized,
  PublicOfferEntityNormalized,
} from '../../../../../../../../../store/product/types';
import { usePublicOfferAssetContext } from '../../../../../contexts/products/PublicOffer';

import { PublicOfferDetailsHeader } from './components/PublicOfferDetailsHeader';
import { PublicOffersModalities } from './components/PublicOffersModalities';

export interface ItemDetailsComponentProps {
  offer: PublicOfferEntityNormalized;
  details: PublicOfferDetailsNormalized | null | undefined;
  onClose: () => void;
  isLoading: boolean;
  error: Error | null | undefined;
}

export const ItemDetails = () => {
  const { height } = Dimensions.get('window');

  const { modalOpen, offerSelected, setModalOpen } = usePublicOfferAssetContext();

  const { data, loading, error } = useRecoilQuery(
    publicOfferDetailsQuery({
      offerId: offerSelected?.offerId,
    })
  );

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  if (!offerSelected) {
    return <></>;
  }

  const props = {
    offer: offerSelected,
    details: data,
    onClose: handleCloseModal,
    isLoading: loading,
    error,
  };

  return (
    <UI.Modal isOpen={modalOpen} onClose={handleCloseModal} testId="modal-details">
      <Modal.Content
        alignItems={'center'}
        w={'full'}
        bgColor={Color['neutral.white']}
        maxH={{ base: height * 0.75, lg: '80vh' }}
        maxW={{ base: 'full', lg: '909px' }}
        marginBottom={{ base: 0, lg: 'none' }}
        marginTop={{ base: 'auto', lg: 0 }}
        padding={{ base: Spacing['inset.xs'], lg: Spacing['inset.md'] }}
        borderRadius={BoxBorder.heavy}>
        <ScrollView w={'full'} showsVerticalScrollIndicator={false}>
          <PublicOfferDetailsHeader {...props} />
          <PublicOffersModalities {...props} />
        </ScrollView>
      </Modal.Content>
    </UI.Modal>
  );
};
